// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3lQX4","modalFooterButton":"ModalNotes_modalFooterButton__2d8mH"};